// import Vue from 'vue'
// import './plugins/element'
// import Vue from 'vue'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI)
import HelloWorld from './components/hello-world/index.js';
import MoorButton from './components/button/index.js';
import MoorSelect from './components/select/index.js';
import MoorInput from './components/input/index.js';
import MoorSwitch from './components/switch/index.js';

const components = [
  HelloWorld,
  MoorButton,
  MoorSelect,
  MoorInput,
  MoorSwitch
]

const install = function(Vue) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  HelloWorld,
  MoorButton,
  MoorSelect,
  MoorInput,
  MoorSwitch
}